var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"refresh-wrap",on:{"click":_vm.refresh}},[_c('Icon',{staticClass:"icon-refresh",class:{ rotate: _vm.refreshLoading },attrs:{"type":"refresh"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }